import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconThumbsDownStyle0 = cosmosIconCss;

const CosmosIconThumbsDown$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconThumbsDown extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'abce02f7fe0acba85bc8abc7ef23b7aea68656c3', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1b8a08a3d6ab8d16b7fd16976409d605971e4e80', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd35920df0151b7b6332bde1a7f4af0816ed4c7b0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 14.002a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h2ZM6.48 6.012a.508.508 0 0 0-.42.22C4.73 8.163 4 9.373 4 11.853a8.996 8.996 0 0 0 .33 2.56.49.49 0 0 0 .47.36c.264 0 1.424-.126 2.53-.246.571-.062 1.128-.123 1.54-.163a18.998 18.998 0 0 0-.48 2.63c0 1.32.88 2.01 2.56 2.01.86 0 1.15-.07 1.28-.43l2.14-5.71c.098-.238.143-.494.13-.75v-4.35a.464.464 0 0 0-.18-.38c-1.491-1.281-3.567-1.31-7.31-1.363l-.53-.007Zm.52 1.5c3.96 0 5.08.18 6 .75v3.97l-1.96 5.27c-.85 0-1.15-.05-1.15-.51 0-.317.202-1.253.518-2.722l.202-.937a.477.477 0 0 0-.54-.6l-4.48.45a9.372 9.372 0 0 1-.09-1.33A6.648 6.648 0 0 1 7 7.513Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconThumbsDownStyle0; }
}, [1, "cosmos-icon-thumbs-down", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-thumbs-down"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-thumbs-down":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconThumbsDown$1);
            }
            break;
    } });
}

const CosmosIconThumbsDown = CosmosIconThumbsDown$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconThumbsDown, defineCustomElement };
